// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Misma marca que Roles (#A61B34) */
.users-page {
  --users-brand: #a61b34;
  --users-brand-border: rgba(166, 27, 52, 0.28);

  flex: 1 1;
  padding: 24px 28px 32px;
  background: #141414;
  color: #f4f4f5;
  min-height: 100%;
  box-sizing: border-box;
}

.users-header h1 {
  margin: 0 0 8px;
  font-size: 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.users-title-icon {
  color: var(--users-brand);
}

.users-subtitle {
  margin: 0 0 24px;
  color: #a1a1aa;
  font-size: 0.95rem;
}

.users-muted {
  color: #71717a;
}

/* Tabla alineada con Sitios (sites-table-container / sites-table) */
.users-table-container {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.users-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #0a0a0a;
  border-bottom: 1px solid #374151;
}

.users-table-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.users-table-loading {
  margin: 0;
  padding: 32px 24px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  background: #1a1a1a;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
}

.users-table thead {
  background: #0a0a0a;
}

.users-table th {
  padding: 16px 24px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #374151;
}

.users-table tbody {
  background: #1a1a1a;
}

.users-table tbody tr {
  border-bottom: 1px solid #374151;
  transition: background-color 0.2s;
}

.users-table tbody tr:hover {
  background: #252525;
}

.users-table td {
  padding: 16px 24px;
  font-size: 14px;
  color: #ffffff;
}

.users-role-select {
  min-width: 160px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #0a0a0a;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.users-role-select:focus {
  border-color: #a61b34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.users-role-locked {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  min-height: 40px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #0a0a0a;
  font-size: 14px;
  color: #e5e7eb;
}

.users-role-locked--form {
  width: 100%;
  box-sizing: border-box;
}

.users-role-locked-name {
  font-weight: 500;
}

.users-role-locked-hint {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #71717a;
}

.users-page .form-group-label-like {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.users-header-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.users-btn-primary,
.users-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.users-btn-primary {
  background: var(--users-brand);
  color: #fff;
}

.users-btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.users-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.users-btn-secondary {
  background: #2a2a2a;
  color: #e4e4e7;
  border: 1px solid #444;
}

.users-btn-secondary:hover {
  background: #333;
}

.users-th-actions {
  width: 140px;
  text-align: right;
}

.users-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.users-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #3f3f46;
  background: #252525;
  color: #d4d4d8;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.users-icon-btn:hover:not(:disabled) {
  background: #2f2f2f;
  border-color: var(--users-brand-border);
}

.users-icon-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.users-icon-btn--danger:hover:not(:disabled) {
  border-color: rgba(239, 68, 68, 0.45);
  color: #f87171;
}

/* Modales de usuarios: mismas clases que inventario (modal-overlay, modal-content, …).
   Z-index por encima del layout de la página por si hiciera falta. */
.users-page .modal-overlay {
  z-index: 1100;
}

.users-perm-intro {
  margin: 0 0 16px;
  font-size: 0.9rem;
  color: #a1a1aa;
  line-height: 1.45;
}

.users-perm-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.users-perm-block {
  padding: 12px 14px;
  border-radius: 10px;
  background: #252525;
  border: 1px solid #333;
}

.users-perm-module {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 8px;
  color: #f4f4f5;
}

.users-perm-subs {
  margin: 0;
  padding-left: 18px;
  color: #d4d4d8;
  font-size: 0.88rem;
  line-height: 1.5;
}

/* Modal edición: misma UX que perfil (checklist + confirmar + ojo) */
.users-page .users-password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.users-page .users-password-input-wrapper input {
  padding-right: 48px;
  width: 100%;
  box-sizing: border-box;
}

.users-page .users-password-toggle-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: color 0.2s;
}

.users-page .users-password-toggle-btn:hover {
  color: #ffffff;
}

.users-page .form-group input.users-edit-input--error {
  border-color: #ef4444;
}

.users-edit-admin-hint {
  margin: 0 0 8px;
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
}

.users-edit-password-checklist {
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 14px 16px;
  background: #252525;
  border: 1px solid var(--users-brand-border);
  border-radius: 10px;
}

.users-edit-password-checklist-title {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: #f4f4f5;
  line-height: 1.35;
}

.users-edit-password-checklist-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.users-edit-password-rule {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.4;
  color: #a1a1aa;
}

.users-edit-password-rule--met {
  color: #e4e4e7;
}

.users-edit-password-rule-icon {
  flex-shrink: 0;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.users-edit-password-check-icon {
  color: #22c55e;
}

.users-edit-password-rule-dash {
  color: #52525b;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
}

.users-edit-password-rule-text {
  flex: 1 1;
  min-width: 0;
}

.users-edit-password-field-error {
  margin: 4px 0 0;
  font-size: 13px;
  color: #f87171;
  line-height: 1.4;
}

.users-edit-admin-pwd {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/UsersPage.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,6CAA6C;;EAE7C,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;qEACqE;AACrE;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":["/* Misma marca que Roles (#A61B34) */\n.users-page {\n  --users-brand: #a61b34;\n  --users-brand-border: rgba(166, 27, 52, 0.28);\n\n  flex: 1;\n  padding: 24px 28px 32px;\n  background: #141414;\n  color: #f4f4f5;\n  min-height: 100%;\n  box-sizing: border-box;\n}\n\n.users-header h1 {\n  margin: 0 0 8px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.users-title-icon {\n  color: var(--users-brand);\n}\n\n.users-subtitle {\n  margin: 0 0 24px;\n  color: #a1a1aa;\n  font-size: 0.95rem;\n}\n\n.users-muted {\n  color: #71717a;\n}\n\n/* Tabla alineada con Sitios (sites-table-container / sites-table) */\n.users-table-container {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.users-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #0a0a0a;\n  border-bottom: 1px solid #374151;\n}\n\n.users-table-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.users-table-loading {\n  margin: 0;\n  padding: 32px 24px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 14px;\n  background: #1a1a1a;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.users-table thead {\n  background: #0a0a0a;\n}\n\n.users-table th {\n  padding: 16px 24px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid #374151;\n}\n\n.users-table tbody {\n  background: #1a1a1a;\n}\n\n.users-table tbody tr {\n  border-bottom: 1px solid #374151;\n  transition: background-color 0.2s;\n}\n\n.users-table tbody tr:hover {\n  background: #252525;\n}\n\n.users-table td {\n  padding: 16px 24px;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n.users-role-select {\n  min-width: 160px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #0a0a0a;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.users-role-select:focus {\n  border-color: #a61b34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.users-role-locked {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  min-height: 40px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #0a0a0a;\n  font-size: 14px;\n  color: #e5e7eb;\n}\n\n.users-role-locked--form {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.users-role-locked-name {\n  font-weight: 500;\n}\n\n.users-role-locked-hint {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #71717a;\n}\n\n.users-page .form-group-label-like {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.users-header-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.users-btn-primary,\n.users-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.users-btn-primary {\n  background: var(--users-brand);\n  color: #fff;\n}\n\n.users-btn-primary:hover:not(:disabled) {\n  filter: brightness(1.08);\n}\n\n.users-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.users-btn-secondary {\n  background: #2a2a2a;\n  color: #e4e4e7;\n  border: 1px solid #444;\n}\n\n.users-btn-secondary:hover {\n  background: #333;\n}\n\n.users-th-actions {\n  width: 140px;\n  text-align: right;\n}\n\n.users-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.users-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid #3f3f46;\n  background: #252525;\n  color: #d4d4d8;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.users-icon-btn:hover:not(:disabled) {\n  background: #2f2f2f;\n  border-color: var(--users-brand-border);\n}\n\n.users-icon-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.users-icon-btn--danger:hover:not(:disabled) {\n  border-color: rgba(239, 68, 68, 0.45);\n  color: #f87171;\n}\n\n/* Modales de usuarios: mismas clases que inventario (modal-overlay, modal-content, …).\n   Z-index por encima del layout de la página por si hiciera falta. */\n.users-page .modal-overlay {\n  z-index: 1100;\n}\n\n.users-perm-intro {\n  margin: 0 0 16px;\n  font-size: 0.9rem;\n  color: #a1a1aa;\n  line-height: 1.45;\n}\n\n.users-perm-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.users-perm-block {\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #252525;\n  border: 1px solid #333;\n}\n\n.users-perm-module {\n  font-weight: 600;\n  font-size: 0.95rem;\n  margin-bottom: 8px;\n  color: #f4f4f5;\n}\n\n.users-perm-subs {\n  margin: 0;\n  padding-left: 18px;\n  color: #d4d4d8;\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n/* Modal edición: misma UX que perfil (checklist + confirmar + ojo) */\n.users-page .users-password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.users-page .users-password-input-wrapper input {\n  padding-right: 48px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.users-page .users-password-toggle-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: color 0.2s;\n}\n\n.users-page .users-password-toggle-btn:hover {\n  color: #ffffff;\n}\n\n.users-page .form-group input.users-edit-input--error {\n  border-color: #ef4444;\n}\n\n.users-edit-admin-hint {\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: #9ca3af;\n  line-height: 1.4;\n}\n\n.users-edit-password-checklist {\n  margin-top: 4px;\n  margin-bottom: 4px;\n  padding: 14px 16px;\n  background: #252525;\n  border: 1px solid var(--users-brand-border);\n  border-radius: 10px;\n}\n\n.users-edit-password-checklist-title {\n  margin: 0 0 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #f4f4f5;\n  line-height: 1.35;\n}\n\n.users-edit-password-checklist-items {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.users-edit-password-rule {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #a1a1aa;\n}\n\n.users-edit-password-rule--met {\n  color: #e4e4e7;\n}\n\n.users-edit-password-rule-icon {\n  flex-shrink: 0;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1px;\n}\n\n.users-edit-password-check-icon {\n  color: #22c55e;\n}\n\n.users-edit-password-rule-dash {\n  color: #52525b;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.users-edit-password-rule-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.users-edit-password-field-error {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #f87171;\n  line-height: 1.4;\n}\n\n.users-edit-admin-pwd {\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
